import React from 'react';
import { string } from 'prop-types';

const QuestionOrAnswer = ({ value, type }) => (

    <p className={`${type}`}>
        {value}
    </p>
);

QuestionOrAnswer.propTypes = {
    value: string.isRequired,
    type: string.isRequired
};

export default QuestionOrAnswer;
